import Vue from 'vue'
// @ts-ignore
import vSelect from 'vue-select'

Vue.component('VSelect', vSelect)
